import { useActiveBanner } from "@/hooks/use-system-banner";
import { BannerSeverity } from "@/api";
import { AlertCircle, AlertTriangle, Info } from "lucide-react";
import { cn } from "@/lib/utils";

export function SystemBanner() {
    const { data: banner } = useActiveBanner();

    if (!banner) return null;

    const severityConfig = {
        [BannerSeverity.Info]: {
            bgColor: "bg-blue-50 dark:bg-blue-950",
            borderColor: "border-blue-200 dark:border-blue-800",
            textColor: "text-blue-900 dark:text-blue-100",
            icon: <Info className="h-5 w-5" />,
        },
        [BannerSeverity.Warning]: {
            bgColor: "bg-orange-50 dark:bg-orange-950",
            borderColor: "border-orange-200 dark:border-orange-800",
            textColor: "text-orange-900 dark:text-orange-100",
            icon: <AlertTriangle className="h-5 w-5" />,
        },
        [BannerSeverity.Critical]: {
            bgColor: "bg-red-50 dark:bg-red-950",
            borderColor: "border-red-200 dark:border-red-800",
            textColor: "text-red-900 dark:text-red-100",
            icon: <AlertCircle className="h-5 w-5" />,
        },
    };

    const config = severityConfig[banner.severity];

    if (!config) return null;

    return (
        <div
            className={cn(
                "sticky top-0 z-50 border rounded-md py-3 m-4",
                config.bgColor,
                config.borderColor,
            )}
        >
            <div className="container mx-auto px-2">
                <div className="flex items-center gap-3">
                    <div className={config.textColor}>{config.icon}</div>
                    <p className={cn("text-sm font-medium", config.textColor)}>
                        {banner.message}
                    </p>
                </div>
            </div>
        </div>
    );
}
